import { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn, focusRing } from './cn';

/** Copies `value` to the clipboard; the icon turns into a check for a moment. */
export function CopyButton({ value, label, className }: { value: string; label?: string; className?: string }) {
  const { t } = useTranslation();
  const name = label ?? t('actions.copy');
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(timer);
  }, [copied]);
  return (
    <button
      type="button"
      aria-label={copied ? t('actions.copied') : name}
      title={name}
      onClick={() => {
        void navigator.clipboard?.writeText(value).then(() => setCopied(true));
      }}
      className={cn(
        'm-0 inline-flex size-5 shrink-0 cursor-pointer items-center justify-center rounded border-0 bg-transparent p-0 text-ink-faint hover:bg-muted hover:text-ink',
        focusRing,
        className,
      )}
    >
      {copied ? <Check size={12} className="text-success-ink" aria-hidden /> : <Copy size={12} aria-hidden />}
    </button>
  );
}
